import { UserManager } from 'paycor-oidc-client';
import config from 'config';

export default () => {
	let manager = new UserManager(config.SECURITYSETTINGS);
	return manager.getAuthorizationHeader();
};
